import React from 'react';
import { Field } from 'react-final-form';

interface HiddenInputComponentProps {
  name: string;
}

export const HiddenInputComponent: React.FC<HiddenInputComponentProps> = React.memo(
  ({ name }: HiddenInputComponentProps) => <Field component="input" name={name} type="hidden" />,
);

HiddenInputComponent.displayName = 'HiddenInputComponent';
